var _path, _g, _path2, _path3, _mask, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelpManual(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9331_5950)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8367 0.899902C12.5356 0.899992 13.9214 2.2924 13.9216 4.0083V11.1245C13.9216 11.134 13.9207 11.1434 13.9207 11.1528C13.9134 12.6157 12.8569 13.824 11.4724 14.0571C11.4391 14.0629 11.4056 14.0681 11.3718 14.0728C11.2458 14.0895 11.1176 14.1011 10.9871 14.1011H5.78491C4.08581 14.1011 2.70007 12.7087 2.69995 10.9927V3.87646C2.69995 3.86734 2.70084 3.85823 2.70093 3.84912C2.70777 2.39845 3.74578 1.19649 5.11304 0.94873C5.16878 0.938369 5.2252 0.930471 5.28198 0.92334C5.39762 0.909353 5.51515 0.899902 5.63452 0.899902H10.8367Z",
    fill: "url(#paint0_linear_9331_5950)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_9331_5950)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.82129,
    y: 10.3916,
    width: 6.85342,
    height: 5.87436,
    rx: 0.906537,
    transform: "rotate(-90 4.82129 10.3916)",
    fill: "#8237FF",
    fillOpacity: 0.5
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 2.16194,
    y: 0.161936,
    width: 17.9769,
    height: 19.1214
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.92px)",
      clipPath: "url(#bgblur_1_9331_5950_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 3.83806,
    d: "M13.5487 4H8.75259C7.01291 4 6 5.01863 6 6.76403V12.6755C6 14.4495 7.01291 15.4453 8.75259 15.4453H13.5487C15.3164 15.4453 16.3007 14.4495 16.3007 12.6755V6.76403C16.3007 5.01863 15.3164 4 13.5487 4Z",
    fill: "#BA90FF",
    fillOpacity: 0.35
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.51887V4.26667C12 4.11939 12.1194 4 12.2667 4H14.7333C14.8806 4 15 4.11939 15 4.26667V7.48182C15 7.69872 14.7548 7.82488 14.5783 7.69881L13.7451 7.10365C13.6573 7.04092 13.5403 7.03731 13.4488 7.09451L12.408 7.745C12.2304 7.85601 12 7.72832 12 7.51887Z",
    fill: "url(#paint1_linear_9331_5950)"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_9331_5950",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6991 9H8.49015C8.2222 9 8 9.22442 8 9.49505C8 9.76568 8.2222 9.9835 8.49015 9.9835H10.6991C10.967 9.9835 11.1892 9.76568 11.1892 9.49505C11.1892 9.22442 10.967 9 10.6991 9ZM8.49017 12.3835H12.0454C12.3133 12.3835 12.5355 12.1591 12.5355 11.8885C12.5355 11.6179 12.3133 11.4 12.0454 11.4H8.49017C8.22222 11.4 8.00002 11.6179 8.00002 11.8885C8.00002 12.1591 8.22222 12.3835 8.49017 12.3835Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6991 9H8.49015C8.2222 9 8 9.22442 8 9.49505C8 9.76568 8.2222 9.9835 8.49015 9.9835H10.6991C10.967 9.9835 11.1892 9.76568 11.1892 9.49505C11.1892 9.22442 10.967 9 10.6991 9ZM8.49017 12.3835H12.0454C12.3133 12.3835 12.5355 12.1591 12.5355 11.8885C12.5355 11.6179 12.3133 11.4 12.0454 11.4H8.49017C8.22222 11.4 8.00002 11.6179 8.00002 11.8885C8.00002 12.1591 8.22222 12.3835 8.49017 12.3835Z",
    fill: "url(#paint2_linear_9331_5950)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49015 9V9.07252H10.6991V9V8.92748H8.49015V9ZM8 9.49505H8.07252C8.07252 9.26379 8.26293 9.07252 8.49015 9.07252V9V8.92748C8.18147 8.92748 7.92748 9.18505 7.92748 9.49505H8ZM8.49015 9.9835V9.91097C8.26167 9.91097 8.07252 9.72504 8.07252 9.49505H8H7.92748C7.92748 9.80631 8.18273 10.056 8.49015 10.056V9.9835ZM10.6991 9.9835V9.91097H8.49015V9.9835V10.056H10.6991V9.9835ZM11.1892 9.49505H11.1167C11.1167 9.72504 10.9276 9.91097 10.6991 9.91097V9.9835V10.056C11.0065 10.056 11.2617 9.80631 11.2617 9.49505H11.1892ZM10.6991 9V9.07252C10.9263 9.07252 11.1167 9.26379 11.1167 9.49505H11.1892H11.2617C11.2617 9.18505 11.0078 8.92748 10.6991 8.92748V9ZM12.0454 12.3835V12.311H8.49017V12.3835V12.4561H12.0454V12.3835ZM12.5355 11.8885H12.463C12.463 12.1197 12.2726 12.311 12.0454 12.311V12.3835V12.4561C12.3541 12.4561 12.608 12.1985 12.608 11.8885H12.5355ZM12.0454 11.4V11.4726C12.2739 11.4726 12.463 11.6585 12.463 11.8885H12.5355H12.608C12.608 11.5772 12.3528 11.3275 12.0454 11.3275V11.4ZM8.49017 11.4V11.4726H12.0454V11.4V11.3275H8.49017V11.4ZM8.00002 11.8885H8.07255C8.07255 11.6585 8.26169 11.4726 8.49017 11.4726V11.4V11.3275C8.18276 11.3275 7.9275 11.5772 7.9275 11.8885H8.00002ZM8.49017 12.3835V12.311C8.26295 12.311 8.07255 12.1197 8.07255 11.8885H8.00002H7.9275C7.9275 12.1985 8.18149 12.4561 8.49017 12.4561V12.3835Z",
    fill: "url(#paint3_linear_9331_5950)",
    mask: "url(#path-5-inside-1_9331_5950)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_9331_5950",
    x: 1.01383,
    y: -0.269371,
    width: 13.4892,
    height: 14.4684,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.90373,
    result: "effect1_foregroundBlur_9331_5950"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_9331_5950_clip_path",
    transform: "translate(-2.16194 -0.161936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5487 4H8.75259C7.01291 4 6 5.01863 6 6.76403V12.6755C6 14.4495 7.01291 15.4453 8.75259 15.4453H13.5487C15.3164 15.4453 16.3007 14.4495 16.3007 12.6755V6.76403C16.3007 5.01863 15.3164 4 13.5487 4Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9331_5950",
    x1: 10.7544,
    y1: 0.899902,
    x2: 10.7544,
    y2: 14.1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC94FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7947C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9331_5950",
    x1: 12,
    y1: 3.46615,
    x2: 14.6667,
    y2: 8.13281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9331_5950",
    x1: 12.214,
    y1: 9.611,
    x2: 7.16609,
    y2: 9.83162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9331_5950",
    x1: 8.72198,
    y1: 9.39419,
    x2: 10.6737,
    y2: 12.6344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9331_5950"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpManual);
export default __webpack_public_path__ + "static/media/helpManual.51c4516693b9218124c9df4a9c7bda10.svg";
export { ForwardRef as ReactComponent };